import { Setter } from "../../services/ComService";
import { parseStringFromServer } from "../../services/TextConverter";
import { CustomerEditFields } from "./CustomerEditFields";
import ItemDTO, { IItem } from "./ItemDTO";

import mainservice from "../../services/MainService";
import { IUserCustomerFkt, UserCustomerFkt, UserCustomerFktDTO } from "./UserCustomerFktDTO";

export default class ItemCustomerDTO extends ItemDTO {
  customerNumber?: number
  eventId: number = -1
  personId: number = -1
  parentId: number = -1
  parentName: string = ''
  parentTown: string = ''
  tagedByUserIds: number[] = []
  userFkts: UserCustomerFktDTO[] = []

  constructor(o: IItemCustomer) {
    super(o)
    this.customerNumber = o.customerNumber
    this.srcAdd = 'spt/customer/add'
    this.srcDel = 'spt/customer/delete'
    this.srcPatch = 'spt/customer/patch'
    this.srcGet = 'spt/customer/get'
    this.srcAddProp = 'spt/customer/prop/add'
    this.srcPatchProp = 'spt/customer/prop/patch' // Wird auf Server Seite überprüft, ob es sich um ein patch handelt
    this.srcDelProp = 'spt/customer/prop/del'
    this.eventId = o.eventId || -1
    this.personId = o.personId || -1
    this.editFields = CustomerEditFields
    this.propOptions = {
      srcAddProp: this.srcAddProp,
      srcPatchProp: this.srcPatchProp,
      srcDelProp: this.srcDelProp,
    }
    this.tagedByUserIds = o.tagedByUserIds || []

    if (this.eventId > -1) {
      this.id = -2
      this.srcGet = 'spt/event/getCustomer'
      this.optionsGet = {
        id: this.eventId
      }
    } else if (this.personId > -1) {
      this.id = -2
      this.srcGet = 'spt/person/getCustomer'
      this.optionsGet = {
        id: this.personId
      }
    }
    this.parentId = o.parentId || -1
    this.parentName = o.parentName || ''
    console.log('### o', o)
    this.afterInit(o)
  }

  getUserFkt(fkt: UserCustomerFkt): number {
    console.log('### ', this, this.userFkts, fkt)
    return this.userFkts.find(f => f.fkt === fkt)?.userId || -1
  }

  isTaggedByUser() {
    return this.tagedByUserIds.some(id => id === mainservice.getUserId())
  }

  async tagForUser() {
    this.tagedByUserIds.push(mainservice.getUserId())
    // TODO Tell server
    await Setter(`spt/customer/usertag`, {
      id: this.id,
    }, {
      method: 'PUT',
    })
  }

  async untagForUser() {
    this.tagedByUserIds = this.tagedByUserIds.filter(id => id !== mainservice.getUserId())
    // TODO Tell server
    await Setter(`spt/customer/usertag`, {
      id: this.id,
    }, {
      method: 'DELETE',
    })
  }

  async toggleTagForUser() {
    if (this.isTaggedByUser()) {
      await this.untagForUser()
    } else {
      await this.tagForUser()
    }
  }

  getCustomerNumber() {
    return this.customerNumber || 'NA'
  }

  afterInit(o: any) {
    this.customerNumber = o.customerNumber
    this.parentId = o.parentId || -1
    this.parentName = o.parentName || ''
    this.parentTown = o.parentTown ? parseStringFromServer(o.parentTown) : ''
    this.userFkts = o.userFkts ? o.userFkts.map((fkt: IUserCustomerFkt) => new UserCustomerFktDTO(fkt)) : []
  }

  public async addPerson(personId: number) {
    await Setter('spt/person/addCustomer', {
      id: personId,
      customerId: this.id,
    })
  }

  public async removePerson(personId: number) {
    await Setter('spt/person/removeCustomer', {
      id: personId,
      customerId: this.id,
    })
  }

  public async addCustomerLocation(customerLocationId: number) {
    await Setter('spt/customer/addLocation', {
      id: this.id,
      locationId: customerLocationId,
    })
  }

  public async addAsCustomerLocation(parentId: number) {
    const result = await Setter('spt/customer/addLocation', {
      id: parentId,
      locationId: this.id,
    })
    this.init(result.item)
  }

  public async unlinkParent() {
    await Setter('spt/customer/unlinkParent', {
      id: this.id,
    })
    this.parentId = -1
    this.parentName = ''
    this.parentTown = ''
  }

  public async unlinkLocation(id: number) {
    await Setter('spt/customer/unlinkParent', {
      id: id,
    })

  }

  public async addEvent(eventId: number) {
    await Setter('spt/event/addCustomer', {
      id: eventId,
      customerId: this.id,
    })
  }

  private infoAbsorberFieldsOutput(lines: string[]) {
    let fields = {
      firstname: '',
      lastname: '',
      email: '',
      phone: '',
      street: '',
      postalcode: '',
      town: '',
      url: '',
      company: '',
      done: false
    }
    if (lines.length > 5 && lines.some(l => l.search(/^ *:? {4}/) > -1)) {
      lines.filter(l => l !== '').map(l => l.replace(/^[: ]*/, '')).forEach((l, index) => {
        switch(index) {
          case 0:
            fields.company = l
            break
          case 1:
            fields.lastname = l
            break
          case 2:
            fields.company = l
            break
          case 3:
            fields.email = l
            break
          case 4:
            fields.phone = l
            break
        }
      })
      fields.done = true
    }
    return fields
  }

  public getCityAndAddress() {
    let cityAndAddress = parseStringFromServer(this.cityAndAddress)
    if (!cityAndAddress) {
      cityAndAddress = [this.getPropV1('data', 'town'), this.getPropV1('data', 'street')].filter(i => i).join(', ')
    }
    return cityAndAddress
  }

  public async infoAbsorber(i: string) {
    let lines = i.split(/\n/)
    
    let fields = this.infoAbsorberFieldsOutput(lines)
    console.log('fields init', fields)
    if (!fields.done) {
      const fieldTests = [
        {
          key: 'company',
          active: true,
          works: 'once',
          scope: /\b[0-9a-zA-ZÄÖÜ].+/,
          action: ((r: string[]) => {
            fields.company = r[0]
          }),
        },
        {
          key: 'street',
          active: true,
          works: 'once',
          scope: /([^0-9(]*[^ 0-9])[^0-9]*(\d+[^ ]*)/,
          action: ((r: string[]) => {
            fields.street = `${r[1]} ${r[2]}`
          }),
        },
        {
          key: 'town',
          active: true,
          works: 'once',
          scope: /([\d^+]+)[- ]*([A-Z].*)/,
          action: ((r: string[]) => {
            fields.postalcode = r[1]
            fields.town = r[2]
          }),
        },
        {
          key: 'email',
          active: true,
          works: 'once',
          scope: /([^ ]+@[^ ]+)/,
          action: ((r: string[]) => {
            fields.email = r[1]
            if (!fields.lastname) {
              fields.lastname = r[1]
            }
          }),
        },
        {
          key: 'url',
          active: true,
          works: 'once',
          scope: /(www\.\S+)/,
          action: ((r: string[]) => {
            fields.url = r[1]
          }),
        },
        {
          key: 'phone',
          active: true,
          works: 'once',
          scope: /([+()0-9][-\/() 0-9]+[0-9])/,
          action: ((r: string[]) => {
            fields.phone = r[1]
          }),
        },
        
        {
          key: 'firstname',
          active: true,
          works: 'once',
          scope: /([^ ].+)/,
          action: ((r: string[]) => {
            if (!fields.firstname) {
              fields.firstname = r[1]
            }
          }),
        },
        {
          key: 'lastname',
          active: true,
          works: 'once',
          scope: /([^ ].+)/,
          action: ((r: string[]) => {
            if (!fields.lastname) {
              fields.lastname = r[1]
            }
          }),
        },
      ]
      console.log('lines', lines)
      lines.forEach(l => {
        fieldTests.some(ft => {
          if (!ft.active) { return false }
          console.log('fieldTest', ft, l, l.match(ft.scope))
          const r = l.match(ft.scope)
          if (!r) { return false }
          ft.action(r)
          ft.active = false
          return true
        })
      })
    }

    this.name = fields.company
    await this.saveToServer()
    await this.addProp('data', 'street', fields.street)
    await this.addProp('data', 'postalcode', fields.postalcode)
    await this.addProp('data', 'town', fields.town)
    await this.addProp('data', 'phone', fields.phone)
    await this.addProp('data', 'url', fields.url)
    await this.addProp('data', 'input', '<p>' + lines.join('<br />') + '</p>')
  }
}

export interface IItemCustomer extends IItem {
  customerNumber?: number,
  eventId?: number,
  personId?: number,
  parentId?: number,
  parentName?: string,
  parentTown?: string,
  tagedByUserIds?: number[],
  userFkts?: IUserCustomerFkt[],
}

